import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Work', href: '#how-we-work' },
  { label: 'Capabilities', href: '#capabilities' },
  { label: 'Approach', href: '#approach' },
  { label: 'Insights', href: '#insights' },
  { label: 'About', href: '#about' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isHome = pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'backdrop-blur-xl bg-background-50/80 border-b border-background-200/70'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer group" aria-label="Prabhaw home">
          <span className={`font-deva text-[26px] md:text-[30px] leading-none tracking-tight transition-colors ${
            scrolled ? 'text-foreground-950 group-hover:text-primary-700' : 'text-white group-hover:text-accent-400'
          }`}>
            प्रभाव
          </span>
          <span className={`hidden sm:block text-[10px] tracking-[0.3em] uppercase font-mono transition-colors ${
            scrolled ? 'text-foreground-500' : 'text-white/60'
          }`}>
            Prabhaw
          </span>
        </Link>

        {/* Desktop nav — centered */}
        <nav
          className={`hidden md:flex absolute left-1/2 -translate-x-1/2 items-center gap-1 px-2 py-1.5 rounded-full border transition-colors ${
            scrolled ? 'border-background-200/70 bg-background-50/60 backdrop-blur-md' : 'border-white/20 bg-white/10 backdrop-blur-md'
          }`}
        >
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={isHome ? l.href : `/${l.href}`}
              className={`px-4 py-1.5 text-xs uppercase tracking-wider rounded-full transition cursor-pointer whitespace-nowrap font-mono ${
                scrolled
                  ? 'text-foreground-600 hover:text-primary-700 hover:bg-primary-100/70'
                  : 'text-white/70 hover:text-white hover:bg-white/10'
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center">
          <a
            href="#contact"
            className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-[13px] font-medium hover:bg-primary-600 transition cursor-pointer whitespace-nowrap"
          >
            <span>Work With Us</span>
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform"></i>
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md border cursor-pointer transition-colors ${
            scrolled
              ? 'border-background-300 text-foreground-950 bg-background-50/70'
              : 'border-white/30 text-white bg-white/10'
          }`}
        >
          <i
            className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl w-5 h-5 flex items-center justify-center`}
          ></i>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-xl">
          <nav className="flex flex-col px-6 py-4 gap-1">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm rounded-md hover:bg-primary-100/60 cursor-pointer font-mono uppercase tracking-wider text-foreground-700 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              Work With Us
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}